import React from "react";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative pt-28 md:pt-36 pb-16 md:pb-24 overflow-hidden">
      <div className="container-ed grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
        <div className="lg:col-span-7 fade-up">
          <div className="overline mb-6">Studio Legale &middot; Lavoro · Civile · Penale</div>
          <h1 className="serif text-5xl sm:text-6xl lg:text-7xl xl:text-[88px] leading-[0.95] tracking-tighter text-[#0F172A]">
            Avv. Scotti <span className="italic text-[#A38A5A]">&amp;</span><br />
            Avv. Bava
          </h1>
          <p className="mt-8 max-w-xl text-base md:text-lg leading-relaxed text-[#57534E]">
            Due professionisti, una visione condivisa: assistenza legale rigorosa
            e umana nel <span className="text-[#0F172A]">diritto del lavoro</span>,
            nel <span className="text-[#0F172A]">diritto civile</span> (locazioni,
            contratti e recupero crediti) e nel{" "}
            <span className="text-[#0F172A]">diritto penale</span>. A fianco di
            privati, professionisti e imprese, tra Bra e Chieti.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a href="#contatti" data-testid="hero-cta-primary" className="btn-primary">
              Richiedi una consulenza
            </a>
            <a href="#materia" data-testid="hero-cta-secondary" className="btn-ghost">
              Aree di competenza
            </a>
          </div>
          <div className="mt-14 hairline pt-6 grid grid-cols-3 gap-6 max-w-lg">
            <div>
              <div className="serif text-3xl md:text-4xl text-[#0F172A]">2</div>
              <div className="overline mt-1 text-[10px]">Sedi</div>
            </div>
            <div>
              <div className="serif text-3xl md:text-4xl text-[#0F172A]">20+</div>
              <div className="overline mt-1 text-[10px]">Anni di pratica</div>
            </div>
            <div>
              <div className="serif text-3xl md:text-4xl text-[#0F172A]">3</div>
              <div className="overline mt-1 text-[10px]">Aree di diritto</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] w-full overflow-hidden bg-[#0B101A]">
            <img
              src="https://static.prod-images.emergentagent.com/jobs/d9f66b95-beed-4fd5-86c5-228cbccaea7e/images/214880d39cad9ccc9bfb826c32dfa4ba09553b3f06f1315897ebffed07e2669d.png"
              alt="Bilancia della giustizia e penna stilografica"
              className="w-full h-full object-cover opacity-95"
              loading="eager"
            />
            <div className="absolute inset-0 ring-1 ring-black/10" />
          </div>
          <div className="hidden lg:block absolute -bottom-8 -left-10 bg-[#FDFBF7] border border-black/10 px-6 py-5 max-w-[280px]">
            <div className="overline text-[10px] mb-2">Principio</div>
            <p className="serif italic text-xl leading-snug text-[#0F172A]">
              "La tutela del lavoro è tutela della persona."
            </p>
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="mt-20 md:mt-28 overflow-hidden border-y border-black/10 py-5 bg-[#FDFBF7]">
        <div className="marquee-track flex gap-16 whitespace-nowrap">
          {Array.from({ length: 2 }).map((_, k) => (
            <div key={k} className="flex items-center gap-16 pr-16">
              {[
                "Diritto del Lavoro",
                "Licenziamenti",
                "Locazioni",
                "Contratti",
                "Recupero crediti",
                "Diritto Penale",
                "Vertenze sindacali",
                "Mobbing",
              ].map((t, i) => (
                <span key={`${k}-${i}`} className="serif italic text-2xl md:text-3xl text-[#0F172A]/70">
                  {t} <span className="text-[#A38A5A] not-italic">·</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
